export default __webpack_public_path__ + "static/logo18-76ed5f5dc7800158daed66fc01317c8e.png";